import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import LooksOneIcon from "@material-ui/icons/LooksOne";
import LooksTwoIcon from "@material-ui/icons/LooksTwo";
import FlipIcon from "@material-ui/icons/Flip";
import { FeaturesContext } from "../MolstackContexts";

const useGroupStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "inherit"
  }
}));

const useButtonStyles = makeStyles(theme => ({
  root: {
    color: "inherit",
    border: "1px solid rgba(255, 255, 255, 0.3)"
  },
  selected: {
    "&$selected": {
      color: "inherit"
    }
  }
}));

function StyledToggleButton(props) {
  const classes = useButtonStyles();
  return (
    <ToggleButton
      classes={{
        root: classes.root,
        selected: classes.selected
      }}
      {...props}
    />
  );
}

export default function ViewTypeButtons(props) {
  const classesGroup = useGroupStyles();
  const classesButton = useButtonStyles();
  const features = useContext(FeaturesContext);

  return (
    <ToggleButtonGroup
      classes={classesGroup}
      value={props.viewType}
      exclusive
      onChange={props.onChange}
    >
      <StyledToggleButton value="split">
        <LooksTwoIcon />
        {/* Split view */}
      </StyledToggleButton>
      <StyledToggleButton value="single">
        <LooksOneIcon />
        {/* Single view */}
      </StyledToggleButton>
      <StyledToggleButton
        value="blend"
        disabled={features.blendedView && !features.blendedView.enabled}
      >
        <FlipIcon />
        {/* Blended view */}
      </StyledToggleButton>
    </ToggleButtonGroup>
  );
}
